import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "loom_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch {
      /* storage blocked — don't show */
    }
  }, []);

  // Reserve space at the bottom of the page while the banner is up, so the fixed
  // banner never overlaps interactive content (e.g. the Sign in button on short
  // phones). Cleared as soon as the user accepts/declines.
  useEffect(() => {
    if (!show) { document.body.style.paddingBottom = ""; return; }
    const h = ref.current?.offsetHeight || 150;
    document.body.style.paddingBottom = `${h + 24}px`;
    return () => { document.body.style.paddingBottom = ""; };
  }, [show]);

  const decide = (value) => {
    try { localStorage.setItem(KEY, value); } catch { /* ignore */ }
    document.body.style.paddingBottom = "";
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      ref={ref}
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[70] w-[calc(100%-2rem)] max-w-2xl
                 rounded-2xl border border-stone-200 bg-white/95 backdrop-blur px-5 py-4 shadow-lg
                 flex flex-col sm:flex-row sm:items-center gap-4"
      data-testid="cookie-consent-banner"
    >
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 text-indigo-500 mt-0.5 shrink-0" />
        <p className="text-sm text-stone-600 leading-relaxed">
          We use essential cookies to keep you signed in and a few analytics cookies to improve Loom.
          See our <Link to="/privacy" className="text-indigo-600 underline">Privacy Policy</Link>.
        </p>
      </div>
      <div className="flex items-center gap-2 sm:ml-auto shrink-0">
        <button
          onClick={() => decide("declined")}
          className="btn-ghost text-sm px-3 py-2"
          data-testid="cookie-decline-button"
        >
          Decline
        </button>
        <button
          onClick={() => decide("accepted")}
          className="btn-primary text-sm px-4 py-2"
          data-testid="cookie-accept-button"
        >
          Accept
        </button>
      </div>
    </div>
  );
}
